import supabase, { getSupabaseBaseUrl } from "@/services/supabaseClient.js";

function parseEventBlock(block) {
  const lines = block.split("\n");
  const event = lines.find((line) => line.startsWith("event:"))?.slice(6).trim() || "message";
  const data = lines.filter((line) => line.startsWith("data:")).map((line) => line.slice(5).trim()).join("\n");
  if (!data) return null;
  try { return { type: event, payload: JSON.parse(data) }; } catch { return null; }
}

/** Browser transport only. The server owns identity, context, tools, and mutations. */
export async function streamFolaOrchestratorTurn(body, onEvent) {
  const { data: session } = await supabase.auth.getSession();
  const token = String(session?.session?.access_token || "").trim();
  const baseUrl = getSupabaseBaseUrl();
  if (!token || !baseUrl) throw new Error("Fola needs an authenticated AfriMed session.");

  const sessionTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const response = await fetch(`${baseUrl}/functions/v1/fola-orchestrator`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "text/event-stream",
    },
    // The server validates this IANA hint and resolves relative dates there.
    // A browser offset is intentionally never treated as temporal authority.
    body: JSON.stringify({ ...body, session_timezone: sessionTimezone }),
  });
  if (!response.ok || !response.body) throw new Error(`Fola request failed (${response.status}).`);

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
    let divider = buffer.indexOf("\n\n");
    while (divider >= 0) {
      const parsed = parseEventBlock(buffer.slice(0, divider));
      // Preserve the event order through an async UI paint boundary. This is
      // not a synthetic delay: it lets each server-sent stage be committed
      // before the following response/action event is processed.
      if (parsed) await onEvent?.(parsed);
      buffer = buffer.slice(divider + 2);
      divider = buffer.indexOf("\n\n");
    }
    if (done) break;
  }
}
